import {create} from 'zustand';

const useFilterStore = create((set) => ({
    filters: {},
    replaceFilters: (data) => {
        set(() => ({
            filters: {...data}
        }))
    }
}))

export default useFilterStore;